import { StyleSheet, Font } from "@react-pdf/renderer";
import robotoItalic from "../fonts/Roboto-CondensedItalic.ttf";

Font.register({
  family: "Roboto-BoldItalic",
  fonts: [{ src: robotoItalic, fontWeight: "bold" }],
});
const styles = StyleSheet.create({
  page: {
    backgroundColor: "#FFFFFF",
    // padding: "10px 25px",
    fontFamily: "Roboto",
  },

  textContent: {
    fontSize: 9,
    marginTop: 1,
    marginBottom: 1,
    fontWeight: 400,
  },

  checkboxWrapper: {
    position: "relative",
    paddingLeft: "20pt",
    paddingRight: "5pt",
  },

  checkbox: {
    border: "1pt solid #000000",
    width: "10pt",
    height: "10pt",
    position: "absolute",
    top: "2pt",
    borderRadius: 100,
  },

  checkboxChecked: {
    border: "1pt solid #000000",
    width: "10pt",
    height: "10pt",
    backgroundColor: "#555555",
    position: "absolute",
    top: "2pt",
    borderRadius: 100,
  },
});

const jsonView = {
  type: "page",
  items: [
    {
      type: "view",
      styles: {
        margin: 5,
        padding: 10,
        marginTop: 0,
        paddingTop: 20,
      },

      items: [
        {
          type: "text",
          styles: {
            ...styles.textContent,
            textAlign: "center",
            fontFamily: "Roboto-Bold",
            fontSize: 14,
          },
          content: "CONTRAT DE TRANSPORT YACHTING A LA JOURNÉE",
        },

        {
          type: "text",
          styles: {
            ...styles.textContent,
            textAlign: "center",
            fontFamily: "Helvetica-Oblique",
            fontSize: 9,
          },
          content: "DAY TRANSPORT AGREEMENT FOR YACHTS ",
        },
        {
          type: "text",
          styles: {
            fontSize: 10,
            textAlign: "center",
            fontFamily: "Roboto-Bold",
            marginBottom: 10,
          },
          content: "N° __agreementUniqueNumber__",
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
            marginVertical: 4,
            marginHorizontal: 4,
          },
          items: [
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },

            {
              type: "text",
              styles: {
                flexDirection: "row",
                justifyContent: "center",
                fontSize: 9,
                fontFamily: "Roboto-Bold",
              },
              content:
                "RENSEIGNEMENTS RELATIFS AU NAVIRE / INFORMATION ABOUT THE VESSEL",
            },
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },
          ],
        },
        {
          type: "view",
          styles: {
            marginLeft: "45pt",
          },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    width: "50%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto-Bold",
                        fontSize: 9,
                      },
                      content: "NOM DU NAVIRE : ",
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 9,
                          },
                          content: "__vesselName__",
                        },
                      ],
                    },
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontSize: 8,
                        fontFamily: "Helvetica-Oblique",
                        marginTop: 0,
                      },
                      content: "Name of Vessel",
                    },
                  ],
                },

                {
                  type: "view",
                  styles: {
                    width: "50%",
                  },
                  items: [
                    {
                      type: "view",
                      styles: {
                        flexDirection: "row",
                        alignItems: "center",
                      },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 8,
                          },
                          content: "N° IMO : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 9,
                            marginLeft: 70,
                          },
                          content: "__imoNumber__",
                        },
                      ],
                    },

                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontSize: 8,
                        fontFamily: "Helvetica-Oblique",
                        marginTop: 0,
                      },
                      content: "IMO Identification number",
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    width: "50%",
                  },
                  items: [
                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 8,
                          },
                          content: "PORT D'ATTACHE : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 9,
                            marginLeft: 10,
                          },
                          content: "__registryPort__",
                        },
                      ],
                    },
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontSize: 8,
                        fontFamily: "Helvetica-Oblique",
                        marginTop: 0,
                      },
                      content: "Port of registry",
                    },
                  ],
                },

                {
                  type: "view",
                  styles: {
                    width: "50%",
                  },
                  items: [
                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 8,
                          },
                          content: "PAVILLION : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 9,
                            marginLeft: 57,
                          },
                          content: "__flagState__",
                        },
                      ],
                    },

                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontSize: 8,
                        fontFamily: "Helvetica-Oblique",
                        marginTop: 0,
                      },
                      content: "Flag",
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    width: "50%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto",
                      },
                      content: "TYPE : ",
                    },
                    {
                      type: "view",
                      specialType: "choice",
                      linkedField: "yachtType",
                      withPadding: true,
                      styles: {
                        flexDirection: "row",
                        fontFamily: "Roboto",
                        marginLeft: 52,
                        fontSize: 9,
                      },
                    },
                  ],
                },

                {
                  type: "view",
                  styles: {
                    width: "50%",
                  },
                  items: [
                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 8,
                          },
                          content: "LONGUEUR HORS TOUT : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 9,
                            marginLeft: 10,
                          },
                          content: "__yachtLOADinMeters__",
                        },
                      ],
                    },

                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontSize: 8,
                        fontFamily: "Helvetica-Oblique",
                        marginTop: 0,
                      },
                      content: "Overall length",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
            marginVertical: 4,
          },
          items: [
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },

            {
              type: "text",
              styles: {
                flexDirection: "row",
                justifyContent: "center",
                fontSize: 9,
                fontFamily: "Roboto-Bold",
              },
              content:
                "RENSEIGNEMENTS RELATIFS AUX OPERATEURS DU CONTRAT/INFORMATION ABOUT THE PARTIES",
            },
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },
          ],
        },

        {
          type: "view",
          styles: {
            marginTop: 2,
            marginBottom: 2,
            border: "1pt solid #000000",
            paddingLeft: 10,
          },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto-Bold",
                    fontSize: 9,
                  },
                  content: "CLIENT : ",
                },
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontSize: 9,
                    marginLeft: 39,
                  },
                  content: "__client__",
                },
              ],
            },
            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontSize: 8,
                fontFamily: "Helvetica-Oblique",
                marginTop: 0,
              },
              content: "Client",
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontSize: 8,
                  },
                  content: "ADRESSE : ",
                },
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontSize: 8,
                    marginLeft: 36,
                  },
                  content:
                    "__clientAddress1__ __clientAddress2__ __clientAddress3__",
                },
              ],
            },

            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontSize: 7,
                fontFamily: "Helvetica-Oblique",
                marginTop: 0,
              },
              content: "Address",
            },
          ],
        },

        {
          type: "view",
          styles: {
            paddingLeft: 10,
            marginTop: 2,
            marginBottom: 2,
            border: "1pt solid #000000",
          },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto-Bold",
                    fontSize: 9,
                  },
                  content: "PRESTATAIRE : ",
                },
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontSize: 9,
                    marginLeft: 13,
                  },
                  content: "__serviceProvider__",
                },
              ],
            },

            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontFamily: "Helvetica-Oblique",
                fontSize: 7,
                marginTop: 0,
              },
              content: "Service Provider",
            },

            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontSize: 8,
                  },
                  content: "ADRESSE & ID : ",
                },
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontSize: 8,
                    marginLeft: 20,
                    width: "80%",
                  },
                  content:
                    "__serviceProviderAddress1__ __serviceProviderAddress2__ ",
                },
              ],
            },
            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontSize: 7,
                fontFamily: "Helvetica-Oblique",
                marginTop: 0,
              },
              content:
                "Address, registration number and country of incorporation",
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto",
                        fontSize: 8,
                      },
                      content: "ASSURANCE : ",
                    },
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto",
                        fontSize: 8,
                        marginLeft: 25,
                      },
                      content: "__serviceProviderInsuranceReference__ ",
                    },
                  ],
                },
              ],
            },

            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontFamily: "Helvetica-Oblique",
                fontSize: 7,
                marginTop: 0,
              },
              content: "Insurance",
            },
          ],
        },

        {
          type: "view",
          styles: {
            marginTop: 2,
            marginBottom: 2,
            border: "1pt solid #000000",
            paddingLeft: 10,
          },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto-Bold",
                    fontSize: 9,
                  },
                  content: "COURTIER : ",
                },
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontSize: 9,
                    marginLeft: 29,
                  },
                  content: "__brokerName__",
                },
              ],
            },

            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontFamily: "Helvetica-Oblique",
                fontSize: 7,
                marginTop: 0,
              },
              content: "Broker",
            },

            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontSize: 8,
                  },
                  content: "ADRESSE & ID: ",
                },
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontSize: 8,
                    marginLeft: 25,
                  },
                  content: "__brokerAddress1__ ",
                },
              ],
            },
            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontSize: 7,
                fontFamily: "Helvetica-Oblique",
                marginTop: 0,
              },
              content:
                "Address, registration number and country of incorporation",
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontSize: 8,
                  },
                  content: "ASSURANCE : ",
                },
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontSize: 8,
                    marginLeft: 29,
                  },
                  content: "__brokerInsurance__",
                },
              ],
            },
            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontFamily: "Helvetica-Oblique",
                fontSize: 7,
                marginTop: 0,
              },
              content: "Insurance",
            },
          ],
        },

        {
          type: "view",
          styles: {
            marginTop: 2,
            marginBottom: 2,
            border: "1pt solid #000000",
            paddingLeft: 10,
          },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto-Bold",
                    fontSize: 9,
                  },
                  content: "AGENT CENTRAL : ",
                },
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontSize: 9,
                    marginLeft: 5,
                  },
                  content: "__centralAgent__",
                },
              ],
            },

            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontFamily: "Helvetica-Oblique",
                fontSize: 7,
                marginTop: 0,
              },
              content: "Central agent",
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontSize: 8,
                  },
                  content: "ADRESSE & ID: ",
                },
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontSize: 8,
                    marginLeft: 25,
                  },
                  content: "__centralAgentAddress1__ __centralAgentAddress2__ ",
                },
              ],
            },

            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontSize: 7,
                fontFamily: "Helvetica-Oblique",
                marginTop: 0,
              },
              content:
                "Address, registration number and country of incorporation",
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontSize: 8,
                  },
                  content: "ASSURANCE : ",
                },
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontSize: 8,
                    marginLeft: 30,
                  },
                  content: "__centralAgentInsurance__",
                },
              ],
            },

            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontFamily: "Helvetica-Oblique",
                fontSize: 7,
                marginTop: 0,
              },
              content: "Insurance",
            },
          ],
        },

        {
          type: "view",
          styles: {
            marginTop: 2,
            marginBottom: 2,
            border: "1pt solid #000000",
            paddingLeft: 10,
          },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto-Bold",
                    fontSize: 9,
                  },
                  content: "SEQUESTRE : ",
                },
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontSize: 9,
                    marginLeft: 22,
                  },
                  content: "__stakeholder__",
                },
              ],
            },

            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontFamily: "Helvetica-Oblique",
                fontSize: 7,
                marginTop: 0,
              },
              content: "Stakeholder",
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontSize: 8,
                  },
                  content: "ADRESSE & ID: ",
                },
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontSize: 8,
                    marginLeft: 25,
                  },
                  content: "__stakeholderAddress1__ __stakeholderAddress2__",
                },
              ],
            },

            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontSize: 7,
                fontFamily: "Helvetica-Oblique",
                marginTop: 0,
              },
              content:
                "Address, registration number and country of incorporation",
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontSize: 8,
                  },
                  content: "ASSURANCE : ",
                },
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontSize: 8,
                    marginLeft: 30,
                  },
                  content: "__stakeHolderInsuranceReference__",
                },
              ],
            },

            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontFamily: "Helvetica-Oblique",
                fontSize: 7,
                marginTop: 0,
              },
              content: "Insurance",
            },
          ],
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
          },
          items: [
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },

            {
              type: "text",
              styles: {
                flexDirection: "row",
                justifyContent: "center",
                fontSize: 9,
                fontFamily: "Roboto-Bold",
              },
              content: "DEFINITION DE LA NAVIGATION / CRUISE PARTICULARS",
            },
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },
          ],
        },
        {
          type: "view",
          styles: {
            padding: 5,
          },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    width: "50%",
                  },
                  items: [
                    {
                      type: "view",
                      styles: {
                        flexDirection: "row",
                        alignItems: "center",
                      },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto-Bold",
                            fontSize: 9,
                          },
                          content: "DE",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontSize: 8,
                            fontFamily: "Roboto",
                            marginLeft: 8,
                          },
                          content: "(Port d'embarquement, jour et heure) : ",
                        },

                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 9,
                            marginLeft: 0,
                          },
                          content: "__embarkationPort__",
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: {
                        flexDirection: "row",
                        alignItems: "center",
                      },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Helvetica-Oblique",
                            fontSize: 7,
                            marginTop: 0,
                          },
                          content: "From (Port of embarkation, date and time)",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 9,
                            paddingLeft: 27,
                          },
                          content: "__cruiseStartDate__ __cruiseStartTime__",
                        },
                      ],
                    },
                  ],
                },

                {
                  type: "view",
                  styles: {
                    width: "50%",
                    flexDirection: "column",
                    paddingLeft: 5,
                  },
                  items: [
                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto-Bold",
                            fontSize: 9,
                          },
                          content: "A ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 8,
                            marginLeft: 6,
                          },
                          content: "(Port de débarquement, jour et heure) : ",
                        },

                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 9,
                            marginLeft: 0,
                          },
                          content: "__disembarkationPort__",
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: {
                        flexDirection: "row",
                        alignItems: "center",
                        gap: 50,
                      },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Helvetica-Oblique",
                            fontSize: 7,
                            marginTop: 0,
                          },
                          content: "To (Port of disembark., date and time)",
                        },
                        {
                          type: "text",
                          styles: {
                            fontFamily: "Roboto",
                            fontSize: 9,
                            marginLeft: 37,
                          },
                          content: "__cruiseEndDate__ __cruiseEndTime__",
                        },
                      ],
                    },
                  ],
                },
              ],
            },

            {
              type: "view",
              styles: {
                flexDirection: "row",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    width: "50%",
                  },
                  items: [
                    {
                      type: "view",
                      styles: {
                        flexDirection: "row",
                        alignItems: "center",
                      },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 8,
                          },
                          content: "PORT INITIAL ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 8,
                          },
                          content: "(pré-acheminement) : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 9,
                            marginLeft: 25,
                          },
                          content: "__deliveryPort__",
                        },
                      ],
                    },

                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Helvetica-Oblique",
                        fontSize: 7,
                        marginTop: 0,
                      },
                      content: "Port of delivery",
                    },
                  ],
                },

                {
                  type: "view",
                  styles: {
                    width: "50%",
                    paddingLeft: 5,
                  },
                  items: [
                    {
                      type: "view",
                      styles: {
                        flexDirection: "row",
                      },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 8,
                          },
                          content: "PORT FINAL ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 8,
                          },
                          content: "(post-acheminement) : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 9,
                            marginLeft: 24,
                          },
                          content: "__redeliveryPort__",
                        },
                      ],
                    },

                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Helvetica-Oblique",
                        fontSize: 7,
                        marginTop: 0,
                      },
                      content: "Port of redelivery",
                    },
                  ],
                },
              ],
            },

            {
              type: "view",
              styles: {},
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto",
                        fontSize: 8,
                      },
                      content: "ZONE DE NAVIGATION/ITINERAIRE :",
                    },
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto",
                        fontSize: 9,
                        marginLeft: 28,
                      },
                      content: "__cruisingArea__",
                    },
                  ],
                },

                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Helvetica-Oblique",
                        fontSize: 7,
                      },
                      content: "Cruising area & Itinerary",
                    },
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        marginLeft: 82,
                        fontFamily: "Roboto",
                        fontSize: 9,
                      },
                      content: "__itineraryDay__",
                    },
                  ],
                },
              ],
            },

            {
              type: "view",
              styles: {
                flexDirection: "row",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    width: "50%",
                  },
                  items: [
                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 8,
                          },
                          content: "NBRE MAXIMUM DE PASSAGERS : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 9,
                            marginLeft: 32,
                          },
                          content: "__paxNb__",
                        },
                      ],
                    },

                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Helvetica-Oblique",
                        fontSize: 7,
                        marginTop: 0,
                      },
                      content: "Maximum number of Passengers on board",
                    },
                  ],
                },

                {
                  type: "view",
                  styles: {
                    width: "50%",
                    paddingLeft: 5,
                  },
                  items: [
                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 8,
                          },
                          content: "DUREE DE NAVIGATION (heures en route) : ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 9,
                            marginLeft: 5,
                          },
                          content: "__totalHoursOfNavigation__",
                        },
                      ],
                    },

                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Helvetica-Oblique",
                        fontSize: 7,
                        marginTop: 0,
                      },
                      content: "Time of navigation (hours vessel underway)",
                    },
                  ],
                },
              ],
            },

            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontSize: 9,
              },
              content: "Le Contrat n’inclut pas d’hébergement de nuit à bord.",
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontSize: 9,
                    fontFamily: "Helvetica-Oblique",
                  },
                  content:
                    "The Agreement does not include night accommodation on board.",
                },
              ],
            },
          ],
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
          },
          items: [
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },
            {
              type: "text",
              styles: {
                flexDirection: "row",
                justifyContent: "center",
                fontSize: 9,
                fontFamily: "Roboto-Bold",
              },
              content: "PRIX DE LA PRESTATION / SERVICE PACKAGE PRICE",
            },
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },
          ],
        },
        {
          type: "view",
          items: [
            {
              type: "view",
              styles: { flexDirection: "row", marginTop: 5 },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "60%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontFamily: "Roboto",
                        fontSize: 8,
                      },
                      content: "PRIX TOTAL FORFAITAIRE DU VOYAGE : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontFamily: "Roboto",
                        fontSize: 9,
                      },
                      content: "__totalPriceExclVat__ ",
                    },
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto",
                        fontSize: 9,
                      },
                      content: " € HORS TVA",
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "40%",
                    justifyContent: "space-between",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontFamily: "Roboto",
                        fontSize: 8,
                      },
                      content: "TAUX DE TVA : ",
                    },
                    {
                      type: "view",
                      styles: { flexDirection: "row", alignItems: "center" },
                      items: [
                        {
                          type: "text",
                          styles: {
                            fontFamily: "Roboto",
                            fontSize: 9,
                            //marginLeft: 65,
                          },
                          content: "__vatRate__ % ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 9,
                          },
                          content: "€ EXC-VAT",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: { flexDirection: "row" },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "60%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontFamily: "Helvetica-Oblique",
                        fontSize: 7,
                      },
                      content: "All-inclusive price of the voyage",
                    },

                    {
                      type: "text",
                      styles: {
                        fontFamily: "Helvetica-Oblique",
                        fontSize: 7,
                        marginLeft: 89,
                      },
                      content: "€ EXC-VAT",
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "40%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Helvetica-Oblique",
                        fontSize: 7,
                      },
                      content: "VAT rate",
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: { flexDirection: "row" },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "60%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontFamily: "Roboto",
                        fontSize: 8,
                      },
                      content: "MONTANT DE LA TVA : ",
                    },
                    {
                      type: "text",
                      styles: {
                        fontFamily: "Roboto",
                        fontSize: 9,
                        marginLeft: 62,
                      },
                      content: "__vatAmount__ ",
                    },
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto",
                        fontSize: 9,
                        marginLeft: 4,
                      },
                      content: " €",
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "40%",
                    justifyContent: "space-between",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontFamily: "Roboto",
                        fontSize: 8,
                      },
                      content: "PRIX TOTAL : ",
                    },
                    {
                      type: "view",
                      styles: {
                        flexDirection: "row",
                        alignItems: "center",
                        marginRight: 19,
                      },
                      items: [
                        {
                          type: "text",
                          styles: {
                            fontFamily: "Roboto",
                            fontSize: 9,
                            //marginLeft: 71,
                          },
                          content: "__totalPriceIncVat__ ",
                        },
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                            fontFamily: "Roboto",
                            fontSize: 9,
                          },
                          content: "€ TTC",
                        },
                        {
                          type: "view",
                          items: [{}],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: { flexDirection: "row" },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "60%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Helvetica-Oblique",
                        fontSize: 7,
                      },
                      content: "VAT amount",
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "40%",
                    justifyContent: "space-between",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontFamily: "Helvetica-Oblique",
                        fontSize: 7,
                      },
                      content: "All-inclusive price of the voyage",
                    },

                    {
                      type: "text",
                      styles: {
                        fontFamily: "Helvetica-Oblique",
                        fontSize: 7,
                        marginRight: 9,
                        //marginLeft: 66,
                      },
                      content: "€ INC-VAT",
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: { flexDirection: "row" },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "60%",
                  },
                  items: [
                    {
                      type: "view",
                      styles: {
                        flexDirection: "row",
                        alignItems: "center",
                      },
                      items: [
                        {
                          type: "text",
                          styles: { fontFamily: "Roboto", fontSize: 8 },
                          content: "RESTAURATION A BORD/",
                        },
                        {
                          type: "text",
                          styles: {
                            fontFamily: "Helvetica-Oblique",
                            fontSize: 6,
                          },
                          content: "catering on board ",
                        },
                        {
                          type: "text",
                          styles: { fontFamily: "Roboto", fontSize: 8 },
                          content: " : ",
                        },
                      ],
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "40%",
                    justifyContent: "space-between",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontFamily: "Roboto",
                        fontSize: 8,
                      },
                      content: "AVANCE SUR FAIS : ",
                    },
                    {
                      type: "view",
                      styles: {
                        flexDirection: "row",
                        alignItems: "center",
                        marginRight: 37,
                      },
                      items: [
                        {
                          type: "text",
                          styles: {
                            fontFamily: "Roboto",
                            fontSize: 9,
                            //marginLeft: 56,
                          },
                          content: "__advanceProvisioning__ ",
                        },
                        {
                          type: "text",
                          styles: {
                            fontFamily: "Roboto",
                            fontSize: 9,
                          },
                          content: "€",
                        },
                        {
                          type: "view",
                          items: [{}],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: { flexDirection: "row" },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "60%",
                    fontSize: 8,
                  },
                  items: [
                    {
                      type: "view",

                      items: [
                        {
                          type: "view",
                          specialType: "choice",
                          linkedField: "onboardCatering",
                          withPadding: true,
                          styles: {
                            flexDirection: "row",
                          },
                          items: [],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "40%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontFamily: "Helvetica-Oblique",
                        fontSize: 7,
                      },
                      content: "Advance provisioning allowance (APA)",
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: { flexDirection: "row" },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "60%",
                  },
                  items: [
                    {
                      type: "view",
                      styles: {
                        flexDirection: "row",
                        alignItems: "center",
                      },
                      items: [
                        {
                          type: "text",
                          styles: { fontFamily: "Roboto-Bold", fontSize: 9 },
                          content: "MONTANT TOTAL DU PAIEMENT : ",
                        },
                        {
                          type: "text",
                          styles: {
                            fontFamily: "Roboto-Bold",
                            fontSize: 9,
                            marginLeft: 5,
                          },
                          content: "__totalAmountPayment__ ",
                        },
                        {
                          type: "text",
                          styles: {
                            fontFamily: "Roboto-Bold",
                            fontSize: 9,
                          },
                          content: "€",
                        },
                      ],
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "40%",
                    justifyContent: "space-between",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontFamily: "Roboto",
                        fontSize: 8,
                      },
                      content: "DEPOT DE GARANTIE : ",
                    },
                    {
                      type: "view",
                      styles: {
                        flexDirection: "row",
                        alignItems: "center",
                        marginRight: 37,
                      },
                      items: [
                        {
                          type: "text",
                          styles: {
                            fontFamily: "Roboto",
                            fontSize: 9,
                            // marginLeft: 45,
                          },
                          content: "__securityDeposit__ ",
                        },
                        {
                          type: "text",
                          styles: {
                            fontFamily: "Roboto",
                            fontSize: 9,
                          },
                          content: "€",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: { flexDirection: "row" },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "60%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Helvetica-Oblique",
                        fontSize: 7,
                      },
                      content: "Total amount of payment",
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "40%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontFamily: "Helvetica-Oblique",
                        fontSize: 7,
                      },
                      content: "Security deposit",
                    },
                  ],
                },
              ],
            },
          ],
        },

        {
          type: "view",
          attrs: { break: true },
          styles: {
            padding: 5,
            display: "block",
            marginTop: 20,
          },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
              },
              items: [
                {
                  type: "view",
                  styles: {
                    flex: 1,
                    height: 1,
                    backgroundColor: "#000",
                    marginTop: 8,
                  },
                  items: [{}],
                },

                {
                  type: "text",
                  styles: {
                    flexDirection: "row",
                    justifyContent: "center",
                    fontSize: 9,
                    fontFamily: "Roboto-Bold",
                  },
                  content: "MODALITES DE PAIEMENT / TERMS OF PAYMENT",
                },
                {
                  type: "view",
                  styles: {
                    flex: 1,
                    height: 1,
                    backgroundColor: "#000",
                    marginTop: 8,
                  },
                  items: [{}],
                },
              ],
            },
            {
              type: "text",
              styles: {
                fontFamily: "Roboto",
                fontSize: 9,
                marginTop: 5,
              },
              content: "__paymentTermsField__",
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontFamily: "Roboto",
                    fontSize: 8,
                  },
                  content: "MOYEN DE PAIEMENT",
                },
                {
                  type: "text",
                  styles: {
                    fontFamily: "Helvetica-Oblique",
                    fontSize: 7,
                  },
                  content: "/Means of payment",
                },
                {
                  type: "text",
                  styles: {
                    fontFamily: "Roboto",
                    fontSize: 9,
                    marginLeft: 40,
                    width: "40%",
                  },
                  content: "__paymentMeans__",
                },
              ],
            },
            {
              type: "view",
              styles: { flexDirection: "row", alignItems: "center" },
              items: [
                {
                  type: "text",
                  styles: {
                    fontFamily: "Roboto-Bold",
                    fontSize: 9,
                  },
                  content: "COORDONNÉES BANCAIRES EN VUE DU VIREMENT",
                },
                {
                  type: "text",
                  styles: {
                    fontFamily: "Roboto-BoldItalic",
                    fontSize: 7,
                    fontWeight: "bold",
                  },
                  content: "/Bank transfer details ",
                },
                {
                  type: "text",
                  styles: {
                    fontFamily: "Roboto-Bold",
                    fontSize: 9,
                  },
                  content: " : ",
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                width: "100%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontFamily: "Roboto",
                    fontSize: 8,
                  },
                  content: "BANQUE",
                },
                {
                  type: "text",
                  styles: {
                    fontFamily: "Helvetica-Oblique",
                    fontSize: 7,
                  },
                  content: "/Bank name",
                },
                {
                  type: "text",
                  styles: {
                    fontFamily: "Roboto",
                    fontSize: 9,
                    marginLeft: 110,
                  },
                  content: "__bankDesignation__",
                },
              ],
            },
            {
              type: "view",
              styles: { flexDirection: "row", alignItems: "center" },
              items: [
                {
                  type: "text",
                  styles: {
                    fontFamily: "Roboto",
                    fontSize: 8,
                  },
                  content: "ADRESSE",
                },
                {
                  type: "text",
                  styles: {
                    fontFamily: "Helvetica-Oblique",
                    fontSize: 7,
                  },
                  content: "/Bank address",
                },
                {
                  type: "text",
                  styles: {
                    fontFamily: "Roboto",
                    fontSize: 9,
                    marginLeft: 100,
                  },
                  content: "__bankAddress1__ __bankAddress2__",
                },
              ],
            },
            {
              type: "view",
              styles: { flexDirection: "row", alignItems: "center" },
              items: [
                {
                  type: "text",
                  styles: {
                    fontFamily: "Roboto",
                    fontSize: 8,
                  },
                  content: "BENEFICIAIRE",
                },
                {
                  type: "text",
                  styles: {
                    fontFamily: "Helvetica-Oblique",
                    fontSize: 7,
                  },
                  content: "/Account name",
                },
                {
                  type: "text",
                  styles: {
                    fontFamily: "Roboto",
                    fontSize: 9,
                    marginLeft: 82,
                  },
                  content: "__bankAccountName__",
                },
              ],
            },

            {
              type: "view",
              styles: { flexDirection: "row" },
              items: [
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "60%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontFamily: "Roboto",
                        fontSize: 8,
                      },
                      content: "IBAN",
                    },
                    {
                      type: "text",
                      styles: {
                        fontFamily: "Roboto",
                        fontSize: 9,
                        marginLeft: 161,
                      },
                      content: "__bankIban__",
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                    width: "40%",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        fontFamily: "Roboto",
                        fontSize: 8,
                      },
                      content: "BIC/SWIFT",
                    },
                    {
                      type: "text",
                      styles: {
                        fontFamily: "Roboto",
                        fontSize: 9,
                        marginLeft: 40,
                      },
                      content: "__bankBicSwift__",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          type: "view",
          styles: {
            flexDirection: "row",
            alignItems: "center",
            marginVertical: 4,
          },
          items: [
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },

            {
              type: "text",
              styles: {
                flexDirection: "row",
                justifyContent: "center",
                fontSize: 9,
                fontFamily: "Roboto-Bold",
              },
              content: "CONDITIONS PARTICULIERES / SPECIAL CONDITIONS",
            },
            {
              type: "view",
              styles: {
                flex: 1,
                height: 1,
                backgroundColor: "#000",
                marginTop: 8,
              },
              items: [{}],
            },
          ],
        },
        {
          type: "view",
          styles: { marginTop: 5 },
          attrs: { wrap: false },
          items: [
            {
              type: "view",
              attrs: { wrap: false },
              styles: {},
              items: [
                {
                  type: "view",
                  styles: {
                    border: "1pt solid #000000",
                    padding: "10px",
                    height: "500px",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                      },
                      content: "__specialConditions__",
                    },
                  ],
                },
              ],
            },
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                marginVertical: 4,
              },
              items: [
                {
                  type: "view",
                  styles: {
                    flex: 1,
                    height: 1,
                    backgroundColor: "#000",
                    marginTop: 8,
                  },
                  items: [{}],
                },

                {
                  type: "text",
                  styles: {
                    flexDirection: "row",
                    justifyContent: "center",
                    fontSize: 9,
                    fontFamily: "Roboto-Bold",
                  },
                  content: "AVENANT AU CONTRAT / RIDER TO THE AGREEMENT",
                },
                {
                  type: "view",
                  styles: {
                    flex: 1,
                    height: 1,
                    backgroundColor: "#000",
                    marginTop: 8,
                  },
                  items: [{}],
                },
              ],
            },
            {
              type: "view",

              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontSize: 6,
                  },
                  content:
                    "Tableau des modifications en cours de voyage, valant avenant au contrat sans impact sur le coût du transport. Indiquer les modifications et paraphez, Client et Capitaine",
                },
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Helvetica-Oblique",
                    fontSize: 7,
                  },
                  content:
                    "Table of changes during the cruise, representing a rider to the Agreemen twithout impact on the contractually agreed price. State change and initial in boxes, Client and Captain.",
                },
                {
                  type: "view",
                  styles: { flexDirection: "row", justifyContent: "flex-end" },
                  items: [
                    {
                      type: "view",
                      styles: {
                        flex: 1,
                        height: 1,
                        backgroundColor: "#000",
                        marginTop: 20,
                        marginRight: 90,
                        position: "relative",
                        width: "100%",
                      },
                      items: [{}],
                    },
                    {
                      type: "view",
                      items: [
                        {
                          type: "view",
                          specialType: "checkbox",
                          styles: {
                            ...styles.checkbox,
                            width: 40,
                            height: 20,
                            right: 40,
                            marginRight: 5,
                            borderRadius: 0,
                          },
                          items: [],
                        },
                      ],
                    },
                    {
                      type: "view",
                      items: [
                        {
                          type: "view",
                          specialType: "checkbox",
                          styles: {
                            ...styles.checkbox,
                            width: 40,
                            height: 20,
                            right: 0,
                            borderRadius: 0,
                          },
                          items: [],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    marginTop: 10,
                  },
                  items: [
                    {
                      type: "view",
                      styles: {
                        flex: 1,
                        height: 1,
                        backgroundColor: "#000",
                        marginTop: 20,
                        marginRight: 90,
                        position: "relative",
                        width: "100%",
                      },
                      items: [{}],
                    },
                    {
                      type: "view",
                      items: [
                        {
                          type: "view",
                          specialType: "checkbox",
                          styles: {
                            ...styles.checkbox,
                            width: 40,
                            height: 20,
                            right: 40,
                            marginRight: 5,
                            borderRadius: 0,
                          },
                          items: [],
                        },
                      ],
                    },
                    {
                      type: "view",
                      items: [
                        {
                          type: "view",
                          specialType: "checkbox",
                          styles: {
                            ...styles.checkbox,
                            width: 40,
                            height: 20,
                            right: 0,
                            borderRadius: 0,
                          },
                          items: [],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    marginTop: 10,
                    marginBottom: 50,
                  },
                  items: [
                    {
                      type: "view",
                      styles: {
                        flex: 1,
                        height: 1,
                        backgroundColor: "#000",
                        marginTop: 20,
                        marginRight: 90,
                        position: "relative",
                        width: "100%",
                      },
                      items: [{}],
                    },
                    {
                      type: "view",
                      items: [
                        {
                          type: "view",
                          specialType: "checkbox",
                          styles: {
                            ...styles.checkbox,
                            width: 40,
                            height: 20,
                            right: 40,
                            marginRight: 5,
                            borderRadius: 0,
                          },
                          items: [],
                        },
                      ],
                    },
                    {
                      type: "view",
                      items: [
                        {
                          type: "view",
                          specialType: "checkbox",
                          styles: {
                            ...styles.checkbox,
                            width: 40,
                            height: 20,
                            right: 0,
                            borderRadius: 0,
                          },
                          items: [],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: "view",
                  repeated: true,
                  findRepeated: "addendumDay_change",
                  styles: {
                    flexDirection: "row",
                    padding: 5,
                    marginBottom: 5,
                  },
                  items: [
                    {
                      type: "view",
                      styles: {
                        width: "70%",
                      },
                      items: [
                        {
                          type: "text",
                          styles: {
                            ...styles.textContent,
                          },
                          content: "__addendumDay_change__",
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: {
                        width: "15%",
                        height: "25pt",
                        border: "1pt solid #000000",
                      },
                      items: [],
                    },

                    {
                      type: "view",
                      styles: {
                        width: "15%",
                        height: "25pt",
                        border: "1pt solid #000000",
                      },
                      items: [],
                    },
                  ],
                },
              ],
            },
          ],
        },

        {
          type: "view",
          styles: {
            flexDirection: "row",
            border: "1pt solid #000000",
            paddingLeft: 5,
            paddingRight: 5,
            top: 30,
          },
          items: [
            {
              type: "view",
              styles: {
                width: "50%",
                borderRight: "1pt solid #000000",
                fontSize: 6,
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontFamily: "Roboto-Bold",
                    fontSize: 9,
                    marginBottom: 5,
                  },
                  content: "ASSURANCES COMPLEMENTAIRES/ADDITIONAL INSURANCES",
                },

                {
                  type: "view",
                  specialType: "choice",
                  linkedField: "insuranceOrNo",
                  items: [
                    {
                      type: "text",
                      styles: { fontSize: 6, fontFamily: "Roboto-Bold" },
                      content: "__insuranceOrNo__",
                    },
                  ],
                },

                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    justifyContent: "center",
                  },
                  items: [
                    {
                      type: "view",
                      styles: {
                        ...styles.checkboxWrapper,
                        paddingLeft: 8,
                        paddingRight: 8,
                      },
                      items: [
                        {
                          type: "view",
                          specialType: "choice",
                          linkedField: "additionalInsuranceLuggage",
                          styles: {
                            ...styles.checkbox,
                            borderRadius: 0,
                            width: "5pt",
                            height: "5pt",
                            marginTop: 3,
                          },
                          items: [],
                        },

                        {
                          type: "text",
                          specialType: "display-everytime",
                          styles: {
                            fontSize: 8,
                            marginBottom: 5,
                            paddingTop: "3pt",
                            textTransform: "uppercase",
                          },
                          content: "BAGAGES",
                          items: [
                            {
                              type: "text",
                              styles: {
                                fontSize: 8,
                                marginBottom: 5,
                                paddingTop: "3pt",
                                textTransform: "uppercase",
                              },
                              content: "__additionalInsuranceLuggage__",
                            },
                          ],
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: {
                        ...styles.checkboxWrapper,
                        paddingLeft: 8,
                        paddingRight: 8,
                      },
                      items: [
                        {
                          type: "view",
                          specialType: "checkbox",
                          linkedField: "additionalInsuranceAssistance",
                          styles: {
                            ...styles.checkbox,
                            borderRadius: 0,
                            width: "5pt",
                            height: "5pt",
                            marginTop: 3,
                          },
                          items: [],
                        },

                        {
                          type: "text",
                          specialType: "display-everytime",
                          styles: {
                            fontSize: 8,
                            marginBottom: 5,
                            paddingTop: "3pt",
                            textTransform: "uppercase",
                          },
                          content: "ASSISTANCE",
                          items: [
                            {
                              type: "text",
                              styles: {
                                fontSize: 8,
                                marginBottom: 5,
                                paddingTop: "3pt",
                                textTransform: "uppercase",
                              },
                              content: "__additionalInsuranceAssistance__",
                            },
                          ],
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: {
                        ...styles.checkboxWrapper,
                        paddingLeft: 8,
                        paddingRight: 8,
                      },
                      items: [
                        {
                          type: "view",
                          specialType: "checkbox",
                          linkedField: "additionalInsuranceCancellation",
                          styles: {
                            ...styles.checkbox,
                            borderRadius: 0,
                            width: "5pt",
                            height: "5pt",
                            marginTop: 3,
                          },
                          items: [],
                        },

                        {
                          type: "text",
                          specialType: "display-everytime",
                          styles: {
                            fontSize: 8,
                            marginBottom: 5,
                            paddingTop: "3pt",
                            textTransform: "uppercase",
                          },
                          content: "ANNULATION",
                          items: [
                            {
                              type: "text",
                              styles: {
                                fontSize: 8,
                                marginBottom: 5,
                                paddingTop: "3pt",
                                textTransform: "uppercase",
                              },
                              content: "__additionalInsuranceCancellation__",
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    marginLeft: 10,
                  },
                  items: [
                    {
                      type: "view",
                      styles: {
                        ...styles.checkboxWrapper,
                      },
                      items: [
                        {
                          type: "text",
                          specialType: "display-everytime",
                          styles: {
                            fontSize: 7,
                            marginBottom: 5,
                            fontFamily: "Helvetica-Oblique",
                          },
                          content: "luggage",
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: {
                        ...styles.checkboxWrapper,
                      },
                      items: [
                        {
                          type: "text",
                          specialType: "display-everytime",
                          styles: {
                            fontSize: 7,
                            marginBottom: 5,
                            fontFamily: "Helvetica-Oblique",
                          },
                          content: "assistance",
                        },
                      ],
                    },

                    {
                      type: "view",
                      styles: {
                        ...styles.checkboxWrapper,
                      },
                      items: [
                        {
                          type: "text",
                          specialType: "display-everytime",
                          styles: {
                            fontSize: 7,
                            marginBottom: 5,
                            fontFamily: "Helvetica-Oblique",
                          },
                          content: "cancellation",
                        },
                      ],
                    },
                  ],
                },

                {
                  type: "view",
                  styles: {
                    ...styles.checkboxWrapper,
                    marginTop: "5pt",
                    borderTop: "1pt solid #000000",
                  },
                  items: [
                    {
                      type: "view",
                      styles: {
                        ...styles.checkbox,
                        borderRadius: 0,
                      },
                      items: [],
                    },

                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontSize: 6,
                      },
                      content:
                        "je déclare avoir été informé des assurances complémentaires bagages, assistance et annulation proposées et ne pas souhaiter y souscrire.",
                    },
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Helvetica-Oblique",
                        fontSize: 6,
                      },
                      content:
                        "I hereby declare that I have been informed about the additional luggage, assistance and cancellation insurance proposed and that I do not wish to take out such insurance.",
                    },
                  ],
                },
                {
                  type: "view",
                  styles: {
                    flexDirection: "row",
                    alignItems: "center",
                  },
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto-Bold",
                        fontSize: 9,
                      },
                      content: "CLIENT : ",
                    },
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto",
                        fontSize: 9,
                      },
                      content: "__client__",
                    },
                  ],
                },

                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    borderBottom: "1pt solid #000000",
                    fontSize: 8,
                    paddingBottom: 5,
                  },
                  content: "DATE ",
                },

                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontSize: 6,
                  },
                  content:
                    "Représenté par « nom, qualité du signataire, adresse complète », dûment habilité à représenter celui-ci pour la signature du présent document",
                },
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Helvetica-Oblique",
                    fontSize: 6,
                  },
                  content:
                    "Represented by “name, capacity of signatory, full address”, duly authorised as the Service Provider’s representative for the signature of this Agreement.​",
                },

                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto-Bold",
                    paddingBottom: 25,
                    fontSize: 9,
                  },
                  content: "SIGNATURE : ",
                },
              ],
            },

            {
              type: "view",
              styles: {
                width: "50%",
              },
              items: [
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto-Bold",
                    textAlign: "center",
                    fontSize: 9,
                  },
                  content: "ATTENTION",
                },
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto",
                    fontSize: 6,
                    paddingLeft: 10,
                    paddingRight: 10,
                  },
                  content:
                    "Le présent contrat est présenté en français et en anglais. En cas de litige entre les Parties sur l’interprétation des clauses de ce contrat, y compris ses annexes, seule la version en français sera considérée comme base juridique de Contrat.",
                },

                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Helvetica-Oblique",
                    fontSize: 6,
                    paddingLeft: 10,
                    paddingRight: 10,
                  },
                  content:
                    "This Agreement is provided in French and in English. In case of a dispute regarding the interpretation of Agreement, only the French version, included its appendices, is regarded as the legal reference of Agreement.",
                },
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    paddingTop: "84pt",
                    fontFamily: "Roboto-Bold",
                    fontSize: 9,
                    paddingLeft: 5,
                  },
                  content: "Prestataire : ",
                  items: [
                    {
                      type: "text",
                      styles: {
                        ...styles.textContent,
                        fontFamily: "Roboto",
                        fontSize: 9,
                      },
                      content: "__serviceProvider__",
                    },
                  ],
                },

                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Helvetica-Oblique",
                    fontSize: 6,
                    marginTop: 0,
                    paddingLeft: 5,
                  },
                  content: "Service provider",
                },

                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    borderBottom: "1pt solid #000000",
                    paddingLeft: 5,
                    fontSize: 8,
                  },
                  content: "DATE ",
                  paddingBottom: 5,
                },

                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontSize: 6,
                    paddingLeft: 5,
                  },
                  content:
                    "Représenté par « nom, qualité du signataire, adresse complète », dûment habilité à représenter celui-ci pour la signature du présent document",
                },
                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Helvetica-Oblique",
                    fontSize: 6,
                    paddingLeft: 5,
                  },
                  content:
                    "Represented by “name, capacity of signatory, full address”, duly authorised as the Service Provider’s representative for the signature of this Agreement.​",
                },

                {
                  type: "text",
                  styles: {
                    ...styles.textContent,
                    fontFamily: "Roboto-Bold",
                    paddingLeft: 5,
                    fontSize: 9,
                  },
                  content: "SIGNATURE : ",
                },

                {
                  type: "view",
                  styles: {
                    height: "50pt",
                  },
                  items: [],
                },
              ],
            },
          ],
        },
      ],
    },
    {
      type: "view",
      attrs: { wrap: false },
      styles: {
        marginTop: "30pt",
        border: "1pt solid #000000",
        flexDirection: "row",
        marginLeft: "9pt",
        marginBottom: "9pt",
      },
      items: [
        {
          type: "view",
          styles: {
            width: "33%",
            borderRight: "1pt solid #000000",
            padding: 5,
          },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                fontSize: 9,
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontFamily: "Roboto-Bold",
                    fontSize: 9,
                    paddingRight: 10,
                  },
                  content: "COURTIER",
                },
                {
                  type: "text",
                  style: {
                    fontFamily: "Roboto",
                    fontSize: 9,
                  },
                  content: "__brokerName__",
                },
              ],
            },

            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontFamily: "Helvetica-Oblique",
                fontSize: 7,
                marginTop: 0,
              },
              content: "Broker",
            },
            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontFamily: "Roboto",
                fontSize: 8,
                marginTop: 10,
              },
              content: "DATE",
            },

            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontSize: 6,
              },
              content:
                "Représenté par « nom, qualité du signataire, adresse complète », dûment habilité à représenter celui-ci pour la signature du présent document.",
            },
            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontFamily: "Helvetica-Oblique",
                fontSize: 6,
                paddingBottom: "50pt",
              },
              content:
                "Represented by “name, capacity of signatory, full address”, duly authorised as the Broker’s representative for the signature of this Agreement.",
            },
          ],
        },

        {
          type: "view",
          styles: {
            width: "33%",
            borderRight: "1pt solid #000000",
            padding: 5,
          },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                fontSize: 9,
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontFamily: "Roboto-Bold",
                    fontSize: 9,
                    paddingRight: 10,
                  },
                  content: "AGENT CENTRAL",
                },
                {
                  type: "text",
                  style: {
                    fontFamily: "Roboto",
                    fontSize: 9,
                    marginLeft: 10,
                  },
                  content: " __centralAgent__",
                },
              ],
            },

            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontFamily: "Helvetica-Oblique",
                fontSize: 6,
                marginTop: 0,
              },
              content: "Central agent",
            },
            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontFamily: "Roboto",
                fontSize: 8,
                marginTop: 10,
              },
              content: "DATE",
            },

            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontSize: 6,
              },
              content:
                "Représenté par « nom, qualité du signataire, adresse complète », dûment habilité à représenter celui-ci pour la signature du présent document.",
            },
            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontFamily: "Helvetica-Oblique",
                fontSize: 6,
                paddingBottom: "50pt",
              },
              content:
                "Represented by “name, capacity of signatory, full address”, duly authorised as the Central Agent’s representative for the signature of this Agreement.",
            },
          ],
        },

        {
          type: "view",
          styles: {
            width: "33%",
            padding: 5,
          },
          items: [
            {
              type: "view",
              styles: {
                flexDirection: "row",
                alignItems: "center",
                fontSize: 9,
              },
              items: [
                {
                  type: "text",
                  styles: {
                    fontFamily: "Roboto-Bold",
                    fontSize: 9,
                    paddingRight: 10,
                  },
                  content: "SEQUESTRE",
                },
                {
                  type: "text",
                  style: { fontFamily: "Roboto", fontSize: 9 },
                  content: "__stakeholder__",
                },
              ],
            },
            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontFamily: "Helvetica-Oblique",
                fontSize: 6,
                marginTop: 0,
              },
              content: "Stakeholder",
            },
            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontFamily: "Roboto",
                fontSize: 8,
                marginTop: 10,
              },
              content: "DATE",
            },

            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontSize: 6,
              },
              content:
                "Représenté par « nom, qualité du signataire, adresse complète », dûment habilité à représenter celui-ci pour la signature du présent document",
            },
            {
              type: "text",
              styles: {
                ...styles.textContent,
                fontFamily: "Helvetica-Oblique",
                fontSize: 6,
                paddingBottom: "50pt",
              },
              content:
                'Represented by "name, capacity of signatory, full address", duly authorised as the Stakeholder\'s representative for signature of this Agreement',
            },
          ],
        },
      ],
    },
  ],
};

export default jsonView;
